import React, { FC } from "react";
import {
  CloseOutlined,
  ManOutlined,
  QuestionOutlined,
  WomanOutlined,
} from "@ant-design/icons";
import { Core_Sex } from "../../src/generated/graphql";
import { Maybe } from "graphql/jsutils/Maybe";

interface SexIconProps {
  sex?: Maybe<Core_Sex>;
}

export const SexIcon: FC<SexIconProps> = ({ sex }) => {
  if (!sex) {
    return <QuestionOutlined />;
  }
  switch (sex) {
    case Core_Sex.SexM:
      return <ManOutlined />;
    case Core_Sex.SexW:
      return <WomanOutlined />;
    case Core_Sex.SexX:
      return <CloseOutlined />;
    default:
      return <QuestionOutlined />;
  }
};
